<div class="container" *ngIf="!isLoading">
    <div class="header">
        <div class="title-container">
            <mat-icon
                class="chevron-left"
                data-cy="ops-settings-system-setting-fcu-view-fcu-back-button"
                svgIcon="chevron-right"
                (click)="backFcuSetting()"></mat-icon>
            <div class="title">
                {{ 'system-settings.fcu.title.fcu-no' | translate: { num: selectedFcuUnit?.index } }}
            </div>
            <div class="sub-title"></div>
        </div>
        <div
            class="edit-text"
            data-cy="ops-settings-system-setting-fcu-view-fcu-edit-button"
            (click)="editFcuUnit()"
            [class.disabled]="!canEditSettings">
            <mat-icon svgIcon="edit-pen"></mat-icon>
            {{ 'system-settings.fcu.button.button' | translate }}
        </div>
    </div>
    <div class="main">
        <div class="content">
            <div class="fcu-container">
                <div class="fcu-header">
                    {{ 'system-settings.fcu.title.fcu-no' | translate: { num: selectedFcuUnit?.index } }}
                </div>
                <div class="fcu-data-container">
                    <div class="communication-container">
                        <div class="fcu-title">
                            {{ 'system-settings.fcu.sub-title.ops-communication' | translate }}
                        </div>
                        <div class="ops-communication-data-container">
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-a-ops' | translate }}
                                </div>
                                <div
                                    class="fcu-data"
                                    data-cy="ops-settings-system-setting-fcu-view-fcu-fcu-a-line-a-ip">
                                    {{ fcuALineAIp }}
                                </div>
                            </div>
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-a-fu' | translate }}
                                </div>
                                <div
                                    class="fcu-data"
                                    data-cy="ops-settings-system-setting-fcu-view-fcu-fcu-a-line-b-ip">
                                    {{ fcuALineBIp }}
                                </div>
                            </div>
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-b-ops' | translate }}
                                </div>
                                <div
                                    class="fcu-data"
                                    data-cy="ops-settings-system-setting-fcu-view-fcu-fcu-b-line-a-ip">
                                    {{ fcuBLineAIp }}
                                </div>
                            </div>
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-b-fu' | translate }}
                                </div>
                                <div
                                    class="fcu-data"
                                    data-cy="ops-settings-system-setting-fcu-view-fcu-fcu-b-line-b-ip">
                                    {{ fcuBLineBIp }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="communication-container">
                        <div class="fcu-title">
                            {{ 'system-settings.fcu.sub-title.fu-communication' | translate }}
                        </div>
                        <div class="ops-communication-data-container">
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-a-ops' | translate }}
                                </div>
                                <div class="fcu-data">
                                    {{ fcuAFieldNetLineAIp }}
                                </div>
                            </div>
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-a-fu' | translate }}
                                </div>
                                <div class="fcu-data">
                                    {{ fcuAFieldNetLineBIp }}
                                </div>
                            </div>
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-b-ops' | translate }}
                                </div>
                                <div class="fcu-data">
                                    {{ fcuBFieldNetLineAIp }}
                                </div>
                            </div>
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-b-fu' | translate }}
                                </div>
                                <div class="fcu-data">
                                    {{ fcuBFieldNetLineBIp }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="communication-container">
                        <div class="fcu-title">
                            {{ 'system-settings.fcu.sub-title.ceu-communication' | translate }}
                        </div>
                        <div class="ops-communication-data-container">
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-a-ops' | translate }}
                                </div>
                                <div class="fcu-data">
                                    {{ fcuACeuCommLineAIp }}
                                </div>
                            </div>
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-a-fu' | translate }}
                                </div>
                                <div class="fcu-data">
                                    {{ fcuACeuCommLineBIp }}
                                </div>
                            </div>
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-b-ops' | translate }}
                                </div>
                                <div class="fcu-data">
                                    {{ fcuBCeuCommLineAIp }}
                                </div>
                            </div>
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.edit.sub-title.fcu-b-fu' | translate }}
                                </div>
                                <div class="fcu-data">
                                    {{ fcuBCeuCommLineBIp }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="communication-container">
                        <div class="ops-communication-data-container">
                            <div class="ops-communication-data">
                                <div class="fcu-title">
                                    {{ 'system-settings.fcu.label.location' | translate }}
                                </div>
                                <div class="fcu-data" data-cy="ops-settings-system-setting-fcu-view-loc">
                                    {{ location }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fcu-slot-data-container">
                    <div class="fcu-title">
                        {{ 'system-settings.fcu.sub-title.slot' | translate }}
                    </div>
                    <div class="slot-item" *ngFor="let slot of slotList">
                        <div class="slot-no">{{ slot.no }}</div>
                        <div
                            class="fcu-data"
                            data-cy="ops-settings-system-setting-fcu-view-fcu-slot"
                            [class.empty]="slot.ioType === EMPTY_SLOT">
                            {{ slot.ioType + doTitle(slot) }}
                        </div>
                    </div>
                </div>
                <div class="external-communication-container">
                    <div class="external-communication-header">
                        <div class="expend-container">
                            <div class="fcu-title">
                                {{ 'system-settings.fcu.sub-title.external-communication' | translate }}
                            </div>
                            <div class="dropdown" (click)="openExpand(0, true)">
                                <span class="dropdown-text">{{ 'system-settings.fcu.dropdown.text' | translate }}</span>
                                <mat-icon svgIcon="dropdown-arrow" [class.rotatedeIcon]="isAllExpanded" />
                            </div>
                        </div>
                        <!-- <button
                            class="edit-button"
                            data-cy="ops-settings-system-setting-fcu-view-fcu-ext-comm-edit-button"
                            (click)="openExternalCommunicationDialog()"
                            [disabled]="!isEditable">
                            {{ 'system-settings.fcu.edit.button' | translate }}
                        </button> -->
                    </div>
                    <div class="expand-list-container">
                        <div class="expand-item-container">
                            <div class="expand-item" *ngIf="externalCommunication">
                                <div class="expand-item-header" (click)="openExtCommExpand()">
                                    <div class="expand-item-index">
                                        {{ 'system-settings.port.ext-comm-title' | translate }}
                                    </div>
                                    <div class="expand-item-type">
                                        {{
                                            'system-settings.port.ext-comm-type'
                                                | translate
                                                    : {
                                                          index: externalCommunication.Ports?.length
                                                              ? externalCommunication.Ports?.length
                                                              : 0,
                                                      }
                                        }}
                                    </div>
                                    <mat-icon svgIcon="dropdown-arrow" [class.rotatedeIcon]="isOpenExtCommExpand" />
                                </div>
                                <div class="expand-port-list" *ngIf="isOpenExtCommExpand">
                                    <div
                                        class="expand-port-item"
                                        *ngFor="let port of externalCommunication.Ports"
                                        [class.disable]="!port.use">
                                        <div class="port-title-container">
                                            <div class="port-no">
                                                {{ port.port }}
                                            </div>
                                            <div class="port-name" [class.not-found]="!port?.commName">
                                                {{ port.commName ? port.commName : 'Name' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngFor="let ceuUnit of ceuList; let i = index" class="expand-item">
                                <div class="expand-item-header" (click)="openExpand(i, false)">
                                    <div class="expand-item-index">
                                        {{ 'system-settings.port.ceu-title' | translate: { num: ceuUnit.index } }}
                                    </div>
                                    <div class="expand-item-type">
                                        {{
                                            ceuUnit.commType +
                                                '(' +
                                                (ceuUnit.Ports?.length ? ceuUnit.Ports?.length : 0) +
                                                ')'
                                        }}
                                    </div>
                                    <mat-icon svgIcon="dropdown-arrow" [class.rotatedeIcon]="isOpenExpand[i]" />
                                </div>
                                <div class="expand-port-list" *ngIf="isOpenExpand[i]">
                                    <div
                                        class="expand-port-item"
                                        *ngFor="let port of ceuUnit.Ports"
                                        [class.disable]="!port.use">
                                        <div class="port-title-container">
                                            <div class="port-no">
                                                {{ port.port }}
                                            </div>
                                            <div class="port-name">
                                                {{ port.commName }}
                                            </div>
                                        </div>
                                        <div class="port-ip" *ngIf="port.commType !== SERIAL">
                                            {{ port.LineIp ? port.LineIp : '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fu-container" *ngFor="let fuUnit of fuList">
                <div class="fu-header">
                    {{ 'system-settings.fu.title-no' | translate: { num: fuUnit.index } }}
                </div>
                <div class="fu-content">
                    <div class="fu-data-container">
                        <div class="fcu-title">
                            {{ 'system-settings.fcu.sub-title.communication' | translate }}
                        </div>
                        <div class="fcu-data" data-cy="ops-settings-system-setting-fcu-view-fu-comm-type">
                            {{ fuUnit.communicationType }}
                        </div>
                    </div>
                    <div class="fu-data-container">
                        <div class="fcu-title">
                            {{ 'system-settings.fcu.label.a-line-ip-address' | translate }}
                        </div>
                        <div class="fcu-data">
                            {{ fuUnit.fieldNetLineAIp }}
                        </div>
                    </div>
                    <div class="fu-data-container">
                        <div class="fcu-title">
                            {{ 'system-settings.fcu.label.b-line-ip-address' | translate }}
                        </div>
                        <div class="fcu-data">
                            {{ fuUnit.fieldNetLineBIp }}
                        </div>
                    </div>
                    <div class="fu-data-container">
                        <div class="fcu-title">
                            {{ 'system-settings.fcu.label.location' | translate }}
                        </div>
                        <div class="fcu-data" data-cy="ops-settings-system-setting-fcu-view-fu-loc">
                            {{ fuUnit.location }}
                        </div>
                    </div>
                    <div class="fu-data-container">
                        <div class="fcu-title">
                            {{ 'system-settings.fcu.sub-title.slot' | translate }}
                        </div>
                        <div class="slot-item" *ngFor="let slot of fuUnit.slotList">
                            <div class="slot-no">{{ slot.no }}</div>
                            <div
                                class="fcu-data"
                                data-cy="ops-settings-system-setting-fcu-view-fu-slot"
                                [class.empty]="slot.ioType === EMPTY_SLOT">
                                {{ slot.ioType + doTitle(slot) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
